import React, { useState, useEffect } from 'react';
import { Container, Grid, Typography, Tabs, Tab, Box } from '@mui/material';
import RoomCard from '../components/room/RoomCard';
import UserCard from '../components/user/UserCard';
import { getFavorites } from '../services/api';
import { useNotification } from '../contexts/NotificationContext';
import LoadingSpinner from '../components/common/LoadingSpinner';

function Favorites() {
    const [tabValue, setTabValue] = useState(0);
    const [favorites, setFavorites] = useState({ rooms: [], users: [] });
    const [loading, setLoading] = useState(true);
    const { showNotification } = useNotification();

    useEffect(() => {
        fetchFavorites();
    }, []);

    const fetchFavorites = async () => {
        try {
            setLoading(true);
            const data = await getFavorites();
            setFavorites(data);
        } catch (error) {
            console.error('お気に入りの取得に失敗:', error);
            showNotification('お気に入りの取得に失敗しました', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    if (loading) return <LoadingSpinner />;

    return (
        <Container>
            <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
                お気に入り一覧
            </Typography>

            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs value={tabValue} onChange={handleTabChange}>
                    <Tab label="お気に入り物件" />
                    <Tab label="お気に入りユーザー" />
                </Tabs>
            </Box>

            {tabValue === 0 ? (
                <Grid container spacing={2}>
                    {favorites.rooms.map(room => (
                        <Grid item xs={12} sm={6} md={4} key={room._id}>
                            <RoomCard
                                room={room}
                                onFavoriteToggle={() => fetchFavorites()}
                            />
                        </Grid>
                    ))}
                    {favorites.rooms.length === 0 && (
                        <Grid item xs={12}>
                            <Typography align="center">
                                お気に入りの物件はありません
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            ) : (
                <Grid container spacing={2}>
                    {favorites.users.map(user => (
                        <Grid item xs={12} sm={6} md={4} key={user._id}>
                            <UserCard
                                user={user}
                                onFavoriteToggle={() => fetchFavorites()}
                            />
                        </Grid>
                    ))}
                    {favorites.users.length === 0 && (
                        <Grid item xs={12}>
                            <Typography align="center">
                                お気に入りのユーザーはありません
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            )}
        </Container>
    );
}

export default Favorites; 